export default function (H) {
  H.setOptions({
    lang: {
      loading: "Cargando...",
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      weekdays: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ],
      shortMonths: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      exportButtonTitle: "Exportar",
      printButtonTitle: "Importar",
      rangeSelectorFrom: "Desde",
      rangeSelectorTo: "Hasta",
      rangeSelectorZoom: "Período",
      downloadPNG: "Descargar imagen PNG",
      downloadJPEG: "Descargar imagen JPEG",
      downloadPDF: "Descargar imagen PDF",
      downloadSVG: "Descargar imagen SVG",
      printChart: "Imprimir",
      resetZoom: "Reiniciar zoom",
      resetZoomTitle: "Reiniciar zoom",
      thousandsSep: ",",
      decimalPoint: ".",
    },
  });
}
